// extracted by mini-css-extract-plugin
export default {"jumpToBottom":"JumpToBottom-module__jumpToBottom__T4DJCuh"};